export const SUPPORT_ARTICLE_LINK = {
  SettingUpPaymentThroughAchBankAccount: 'https://support.shipbob.com/s/article?articleName=Setting-up-Payment-through-ACH-Bank-Account'
}
